module.exports = __webpack_public_path__ + "img/07.d7e9db39.jpg";